export default __webpack_public_path__ + "static/media/SD.698f5803.ico";